export const statuses = {
  INITIALIZED: -1,
  DISCONNECTED: 0,
  CONNECTING: 1,
  CONNECTED: 2,
  ERRORED: 3,
  STOPPED: 4,
};

export const eventTypes = {
  connected: 'connected',
  disconnected: 'disconnected',
  reconnected: 'reconnected',
  notification: 'notification',
  progress: 'progress',
  message: 'message',
  statusChanged: 'statusChanged',
  error: 'error',
};

export const messageSources = {
  progress: 0,
  notification: 1
};

export const messageStatuses = {
  starting: 0,
  info: 1,
  success: 2,
  error: 3,
};

export const logLevel = {
  quiet: -2,
  force: -1,
  error: 0,
  warning: 1,
  info: 2,
  trace: 3,
};